let title = {
  text: '车辆保养费用统计'
}

let tooltip = {
  trigger: 'axis',
  axisPointer: {
    type: 'shadow'
  }
}

let legend = {}

let grid = {
  left: '3%',
  right: '4%',
  bottom: '3%',
  containLabel: true
}

let xAxis = {
  type: 'value',
  boundaryGap: [0, 0.01]
}

let toolbox = {
  show: true,
  itemSize: 20,
  itemGap: 30,
  right: 50,
  feature: {
    dataView: { show: true },
    saveAsImage: {
      //excludeComponents :['toolbox'],
      pixelRatio: 2,
    },
  },
}

let itemStyle = {
  barBorderRadius: 5,
  borderWidth: 1,
  borderType: "solid",
  borderColor: "#73c0de",
  shadowColor: "#5470c6",
  shadowBlur: 3,
}

function getMaintainCostOption(yAxisArr, series) {
  let option = {
    title,
    tooltip,
    legend,
    grid,
    toolbox,
    itemStyle,
    xAxis,
    yAxis: {
      type: 'category',
      data: yAxisArr,
      splitLine: {
        show: true
      }
    },
    series,
  }
  return option
}

function reOrganizeMaintainCostData(data, quarter) {
  let yAxisArr = []
  let series = []
  let seriesMap = new Map()
  let len = 0
  if (data && data.length > 0) {
    data.forEach((item) => {
      // 装配y轴 年度或季度
      let yAxisOne
      if (quarter) {
        yAxisOne = `${item.yearStr}年${item.quarter}季度`
        if (!yAxisArr.includes(yAxisOne)) {
          yAxisArr.push(yAxisOne)
          len += 1
        }
      } else {
        yAxisOne = `${item.yearStr}年`
        if (!yAxisArr.includes(yAxisOne)) {
          yAxisArr.push(yAxisOne)
          len += 1
        }
      }
    })
    data.forEach((item) => {
      let yAxisOne
      if (quarter) {
        yAxisOne = `${item.yearStr}年${item.quarter}季度`
      } else {
        yAxisOne = `${item.yearStr}年`
      }
      let carNum = item.carNum
      // 装配数据seriesMap 根据车牌号分系列
      if (!seriesMap.has(carNum)) {
        let arr = []
        for (let i = 0; i < len; i++) {
          arr.push({ [yAxisArr[i]]: 0 })
        }
        arr.forEach((itemIn) => {
          if (yAxisOne in itemIn) {
            itemIn[yAxisOne] = item.maintainCost
          }
        })
        seriesMap.set(carNum, arr)
      } else {
        let arr = seriesMap.get(carNum)
        arr.forEach((itemIn) => {
          if (yAxisOne in itemIn) {
            itemIn[yAxisOne] = item.maintainCost
          }
        })
      }
    })
    // 装配series
    series = [...seriesMap].map((item) => {
      return {
        name: item[0],
        type: 'bar',
        showBackground: true,
        backgroundStyle: {
          color: "rgba(220, 220, 220, 0.8)",
        },
        label: {
          show: true,
          formatter: (params) => {
            return `【${params.seriesName}】---（${params.data}）`
          },
          position: "right",
          color: 'inherit',
          fontSize: 14,
          fontWeight: 'bold'
        },
        data: item[1].map((itemIn) => { return Object.values(itemIn)[0] }),
        itemStyle: {
          normal: {
            color: getRandomColor()
          }
        },
        emphasis: {
          focus: 'series',
        },
      }
    })
    return { yAxisArr, series }
  }
}

const getRandomColor = function () {
  var color = "#";
  // 使用for循环6次，模拟生成6位16进制颜色码
  for (var i = 0; i < 6; i++) {
    // Math.random() * 16 生成一个0到15之间的随机浮点数，
    // 然后使用按位或操作符(|)与0进行运算，将其转换为整数
    // 这样可以确保结果是0到15之间的整数
    // toString(16)将这个整数转换成16进制字符串
    // 将生成的随机16进制字符追加到color字符串中
    color += ((Math.random() * 16) | 0).toString(16);
  }
  return color;
}

export { reOrganizeMaintainCostData, getMaintainCostOption }
